import iIcon from './icon';

export default function ErrorTriangle({ fill = 'currentColor', width, height, title = undefined }: iIcon) {
  return (
    <svg width={width ?? 48} height={height ?? 48} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      {title && <title>{title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0283 4.51169C21.7162 1.31901 26.2837 1.31902 27.9717 4.5117L47.4716 41.394C49.0561 44.391 46.8864 47.9995 43.4998 47.9995H4.50015C1.11359 47.9995 -1.05611 44.391 0.528416 41.394L20.0283 4.51169ZM28.5 37.4996C28.5 39.9849 26.4853 41.9996 24 41.9996C21.5147 41.9996 19.5 39.9849 19.5 37.4996C19.5 35.0143 21.5147 32.9996 24 32.9996C26.4853 32.9996 28.5 35.0143 28.5 37.4996ZM22 14.9996C21.4477 14.9996 21 15.4473 21 15.9996V28.9996C21 29.5519 21.4477 29.9996 22 29.9996H26C26.5523 29.9996 27 29.5519 27 28.9996V15.9996C27 15.4473 26.5523 14.9996 26 14.9996H22Z"
        fill={fill}
      />
    </svg>
  );
}
